import { render, staticRenderFns } from "./EmployersTable.vue?vue&type=template&id=59ba0adb&"
import script from "./EmployersTable.vue?vue&type=script&lang=js&"
export * from "./EmployersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports